<ng-container *ngIf="partners$ | async as partners">
  <ng-conatiner *ngIf="partners.length; else noPartners">
    <div class="points-transfer mb-4 mb-lg-0" [formGroup]="transferPointsForm">
      <h4 class="title text-uppercase font-size-18">{{ 'point.transfer.title' | translate }}</h4>
      <div class="points-transfer-header font-size-14">
        <div class="text-left" [innerHTML]="'point.transfer.card.title.1' | translate"></div>
      </div>
      <div class="row align-items-center justify-content-center">
        <div class="form-partner">
          <div class="form-floating">
            <select class="form-select" id="floatingSelect" formControlName="partnerSelected">
              <option selected="true" hidden [value]="null">{{ 'select.partner.placeholder' | translate }}</option>
              <option *ngFor="let partner of partners" [ngValue]="partner">{{ partner.FullName }} ({{ partner.Email }})</option>
            </select>
            <label for="floatingSelect">{{ 'point.transfer.my.partner' | translate }}</label>
          </div>
          <div class="points">
            <fgbcl-number-input
              [isActive]="true"
              [minValue]="1"
              [maxValue]="balance"
              [incrementValue]="1"
              [theme]="auction"
              [(amount)]="amount"
              [ngClass]="{ 'is-invalid': !!transferPointsForm.controls.Amount.errors }"
              [minMessage]="'1 point is the minimum'"
              [maxMessage]="'You do not have enough points'"
            >
            </fgbcl-number-input>
          </div>
        </div>
      </div>
      <button (click)="send()" [disabled]="transferPointsForm.invalid" class="btn btn-primary text-white send-button">
        {{ 'point.transfer.send' | translate }}
      </button>

      <!-- Confirm modal -->
      <ng-template #confirmModal>
        <div class="points-transfer-modal font-size-12">
          <div class="modal-header d-flex align-items-center font-size-14 fw-bold">
            {{ 'point.transfer.confirm.text' | translate }}
          </div>
          <div class="content">
            <div class="partner-details font-size-12">
              <label class="lbl">{{ 'point.transfer.person.detail' | translate }}</label>
              <span>
                {{ transferPointsForm.controls.partnerSelected.value.FullName }} ({{
                  transferPointsForm.controls.partnerSelected.value.Email
                }})
              </span>
            </div>
            <div class="points-value font-size-12">
              <label class="lbl">{{ 'point.transfer.point.value' | translate }}</label>
              <span>
                {{ transferPointsForm.controls.Amount.value }}
              </span>
            </div>
          </div>

          <div class="action-wrapper d-flex justify-content-end">
            <button type="button" class="btn text-danger fw-bold" (click)="closeModal()">
              {{ 'point.transfer.cancel' | translate }}
            </button>
            <button type="button" class="btn text-white btn-confirm fw-bold" (click)="transferPoints()">
              {{ 'point.transfer.confirm' | translate }}
            </button>
          </div>
        </div>
      </ng-template>
    </div>
  </ng-conatiner>
  <ng-template #noPartners>
    <div class="card text-center p-3 no-partner-container">
      <div class="font-size-14">{{ 'point.transfer.no.partner' | translate }}</div>
    </div>
  </ng-template>
</ng-container>
